import { GetCrossCourseLinkedSectionsCommand } from '../../../components/section_corequisite/commands/get_cross_course_linked_sections_command';
import { ClearCrossCourseLinkedSectionsCommand } from '../../../components/section_corequisite/commands/clear_cross_course_linked_sections_command';
import { GetCourseDetailsCommand } from '../commands/get_course_details_command';
import { ISection, ITermCourse } from '../../../interfaces/scheduler_interfaces';
import { CommunicatorService } from 'ui-ng-component-communicator';
import * as _4 from 'lodash4';
import { IQuery } from 'core-ts-types';

export class CourseDetailsFacade {
  constructor(
    private getCrossCourseLinkedSectionsCommand: GetCrossCourseLinkedSectionsCommand,
    private getCourseDetailsCommand: GetCourseDetailsCommand,
    private $q: ng.IQService,
    private ngComponentCommunicatorService: CommunicatorService,
    private clearCrossCourseLinkedSectionsCommand: ClearCrossCourseLinkedSectionsCommand
  ) {}

  hasLinkedSection(section?: ISection): section is ISection {
    if (!section) {
      return false;
    }
    return !_4.isEmpty(section._linked_sections);
  }

  openCourseDetails(courseNk: ITermCourse['nk'], section?: ISection) {
    return this.clearCrossCourseLinkedSectionsCommand()
      .then(() =>
        this.$q.all(this.hasLinkedSection(section) ? [this.getCrossCourseLinkedSectionsCommand(section.id, true)] : [])
      )
      .then(() => this.getCourseDetailsCommand(courseNk, section ? section['id'] : undefined))
      .then(() => {
        this.ngComponentCommunicatorService.publish('OPEN_COURSE_DETAIL_MODAL');
      });
  }
}

angular.module('capability-ng-scheduler').service('ngCourseDetailsFacade', CourseDetailsFacade);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_details/facades/course_details_facade.ts